import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Underline = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3115 1.82827C13.8334 1.82827 13.4458 2.21584 13.4458 2.69393V10.3517C13.4458 11.0018 13.4218 11.5804 13.1358 12.0875C12.854 12.5903 12.4466 12.9868 11.9135 13.2772C11.3804 13.5633 10.7433 13.7063 10.0022 13.7063C9.26103 13.7063 8.62391 13.5633 8.09081 13.2772C7.56204 12.9868 7.15463 12.5903 6.86858 12.0875C6.58252 11.5804 6.55361 11.0018 6.55361 10.3517V2.69148C6.55361 2.21475 6.16714 1.82827 5.6904 1.82827C5.21366 1.82827 4.82719 2.21475 4.82719 2.69148V10.7567C4.82719 11.6669 5.03956 12.4796 5.46431 13.1947C5.89339 13.9055 6.49584 14.4668 7.27165 14.8785C8.04747 15.2859 8.95764 15.4896 10.0022 15.4896C11.0467 15.4896 11.9569 15.2859 12.7327 14.8785C13.5085 14.4668 14.1088 13.9055 14.5335 13.1947C14.9626 12.4796 15.1771 11.6669 15.1771 10.7567V2.69393C15.1771 2.21584 14.7896 1.82827 14.3115 1.82827ZM4.52571 17.4845C4.05982 17.4845 3.68213 17.8622 3.68213 18.3281C3.68213 18.7939 4.05981 19.1716 4.52571 19.1716H15.4743C15.9402 19.1716 16.3179 18.7939 16.3179 18.3281C16.3179 17.8622 15.9402 17.4845 15.4743 17.4845H4.52571Z"
        fill={color}
      />
    </svg>
  )
})

export default Underline
